import { render, staticRenderFns } from "./threeDialog.vue?vue&type=template&id=1e984daf&scoped=true"
import script from "./threeDialog.vue?vue&type=script&lang=js"
export * from "./threeDialog.vue?vue&type=script&lang=js"
import style0 from "./threeDialog.vue?vue&type=style&index=0&id=1e984daf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e984daf",
  null
  
)

export default component.exports